import type { ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import type { DiaryType } from "@kiddocare-platform/portal-common/family";
import { isCacheValid } from "../../../entry.cache";
import type { FamilyCacheState } from "../types";

const addDiaryTypeKey: CaseReducer<
  FamilyCacheState,
  PayloadAction<{ key: string; value: ResponseMessage<DiaryType> }>
> = (state, action) => {
  const { key, value } = action.payload;
  state.diaryType[key] = { value, cachedAt: Date.now() };
};

const removeDiaryTypeKey: CaseReducer<
  FamilyCacheState,
  PayloadAction<string>
> = (state, action) => {
  delete state.diaryType[action.payload];
};

const purgeExpiredDiaryTypeCache: CaseReducer<FamilyCacheState> = (state) => {
  for (const key of Object.keys(state.diaryType)) {
    if (!isCacheValid(state.diaryType[key])) {
      delete state.diaryType[key];
    }
  }
};

export const diaryTypeReducers = {
  addDiaryTypeKey,
  removeDiaryTypeKey,
  purgeExpiredDiaryTypeCache,
};
